import { supabase } from "../lib/supabase";

const API_BASE = process.env.REACT_APP_API_BASE || "";

async function authHeadersMultipart() {
  const {
    data: { session },
  } = await supabase.auth.getSession();
  const token = session?.access_token;
  if (!token) {
    throw new Error("Bitte melde dich an.");
  }
  return { Authorization: `Bearer ${token}` };
}

async function authHeadersJson() {
  const {
    data: { session },
  } = await supabase.auth.getSession();
  const token = session?.access_token;
  if (!token) {
    throw new Error("Bitte melde dich an.");
  }
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
}

/**
 * Upload a flyer/screenshot — async extraction (202).
 * @param {File} file
 */
export async function uploadCaptureImage(file) {
  const headers = await authHeadersMultipart();
  const form = new FormData();
  form.append("image", file);

  const res = await fetch(`${API_BASE}/api/image-captures`, {
    method: "POST",
    headers,
    body: form,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || `Upload fehlgeschlagen (${res.status}).`);
  }
  return data;
}

/**
 * @param {string} captureId
 */
export async function fetchImageCapture(captureId) {
  const headers = await authHeadersJson();
  const res = await fetch(
    `${API_BASE}/api/image-captures/${encodeURIComponent(captureId)}`,
    { headers },
  );
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || `Laden fehlgeschlagen (${res.status}).`);
  }
  return data;
}

/**
 * @param {string} captureId
 * @param {{ items: object[] }} body
 */
export async function confirmImageCapture(captureId, body) {
  const headers = await authHeadersJson();
  const res = await fetch(
    `${API_BASE}/api/image-captures/${encodeURIComponent(captureId)}/confirm`,
    {
      method: "POST",
      headers,
      body: JSON.stringify(body),
    },
  );
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || `Speichern fehlgeschlagen (${res.status}).`);
  }
  return data;
}

/**
 * Photo captures still waiting: processing or ready, last 7 days.
 */
export async function fetchOpenImageCaptures() {
  const headers = await authHeadersJson();
  const res = await fetch(`${API_BASE}/api/image-captures`, { headers });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || `Laden fehlgeschlagen (${res.status}).`);
  }
  return data;
}

/**
 * @param {string} captureId
 */
export async function cancelImageCapture(captureId) {
  const headers = await authHeadersJson();
  const res = await fetch(
    `${API_BASE}/api/image-captures/${encodeURIComponent(captureId)}/cancel`,
    { method: "POST", headers },
  );
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || `Abbrechen fehlgeschlagen (${res.status}).`);
  }
  return data;
}
